import { render, staticRenderFns } from "./OnboardingRunSummary.vue?vue&type=template&id=8df53a34&scoped=true"
import script from "./OnboardingRunSummary.vue?vue&type=script&lang=js"
export * from "./OnboardingRunSummary.vue?vue&type=script&lang=js"
import style0 from "./OnboardingRunSummary.vue?vue&type=style&index=0&id=8df53a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df53a34",
  null
  
)

export default component.exports